module.exports = __webpack_public_path__ + "img/22.df3dae06.png";